import { Box, Modal, Typography } from "@mui/material";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500, // Increase width for better layout
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  borderRadius: "10px", // Add rounded corners for a cleaner look
  p: 4,
};

// Component to render error details with improved styling
function ErrorDetails({ errors, style }) {
  return (
    <>
      {errors?.map(({ key, value }, index) => (
        <Box key={index} sx={{ mt: 2, ...(style && style) }}>
          <Typography variant="body2" color="textSecondary">
            {key}: {value}
          </Typography>
        </Box>
      ))}
    </>
  );
}

export const GenericModal = ({
  open,
  onClose,
  data: { title, message, errors },
  style = {},
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={defaultStyle}>
        {title && (
          <Typography
            variant="h6"
            sx={{ mb: 2, ...(style.title && style.title) }}
          >
            {title}
          </Typography>
        )}
        {message && (
          <Typography
            variant="body1"
            sx={{ mb: 2, ...(style.message && style.message) }}
          >
            {message}
          </Typography>
        )}
        {errors.length > 0 && (
          <ErrorDetails errors={errors} style={style.errors} />
        )}
      </Box>
    </Modal>
  );
};
